import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WorkflowArea } from '@modeso/aumico-lib-cpmm-fe/enums/workflow-area.enum';
import { I18NextService } from 'angular-i18next';

@Component({
    selector: 'app-sync-banner',
    templateUrl: './app-sync-banner.component.html',
    styleUrls: ['./app-sync-banner.component.scss'],
})
export class SyncBannerComponent {
    constructor(private i18next: I18NextService) {}
    @Input() isVisible: boolean = false;
    @Input() workflowArea: WorkflowArea = WorkflowArea.MANDATE_MANAGEMENT;
    @Output() dismiss = new EventEmitter<void>();
    @Output() sync = new EventEmitter<void>();

    onDismiss() {
        this.dismiss.emit();
    }

    onSync() {
        this.sync.emit();
    }

    get message(): string | null {
        if (this.workflowArea === WorkflowArea.MANDATE_MANAGEMENT) {
            return this.i18next.t('aumico_MM_sync_banner').toString();
        } else {
            return this.i18next.t('aumico_CP_sync_banner').toString();
        }
    }
}
